import { render, staticRenderFns } from "./PriceIntelligence.vue?vue&type=template&id=9ba429ac&scoped=true"
import script from "./PriceIntelligence.vue?vue&type=script&lang=js"
export * from "./PriceIntelligence.vue?vue&type=script&lang=js"
import style0 from "./PriceIntelligence.vue?vue&type=style&index=0&id=9ba429ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba429ac",
  null
  
)

export default component.exports